export default class {
    /**
     * Create a new Errors instance.
     */
    constructor() {
        this.errors = {};
    }

    /**
     * Determine if an errors exists for the given field.
     *
     * @param {string} field
     */
    has(field) {
        return this.errors.hasOwnProperty(field);
    }

    /**
     * Determine if we have any errors.
     */
    any() {
        return Object.keys(this.errors).length > 0;
    }

    /**
     * Retrieve the error message for a field.
     *
     * @param {string} field
     */
    get(field) {
        if (this.errors[field]) {
            if (Array.isArray(this.errors[field])) {
                return this.errors[field][0];
            }

            return this.errors[field];
        }
    }

    /**
     * Record the new errors.
     *
     * @param {object} errors
     */
    record(errors) {
        this.errors = errors;
    }

    /**
     * Set one or more errors, merging with the existing ones.
     *
     * @param {string|object} field  A field name, or an object of { field: messages }.
     * @param {string|string[]} [messages]
     */
    set(field, messages) {
        if (field !== null && typeof field === 'object') {
            this.errors = { ...this.errors, ...field };
            return;
        }

        this.errors = {
            ...this.errors,
            [field]: Array.isArray(messages) ? messages : [messages]
        };
    }

    /**
     * Clear one or all error fields.
     *
     * @param {string|null} field
     */
    clear(field) {
        if (field) {
            delete this.errors[field];
            return true;
        }

        this.errors = {};
    }
}
